import React from 'react';

interface DesktopPlazaLayoutProps {
  leftPanel?: React.ReactNode;
  centerPanel: React.ReactNode;
  rightPanel?: React.ReactNode;
}

/**
 * PC用3カラムレイアウトコンポーネント
 * 左・中央・右の3つのパネルを同時表示
 */
const DesktopPlazaLayout: React.FC<DesktopPlazaLayoutProps> = ({
  leftPanel,
  centerPanel,
  rightPanel
}) => {
  return (
    <div style={{
      display: 'flex',
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    }}>
      {/* 左パネル */}
      <div style={{
        flex: '0 0 30%',
        minWidth: '300px',
        maxWidth: '400px',
        background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 50%, #dde9ff 100%)',
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {leftPanel || (
          <div style={{ 
            textAlign: 'center',
            color: '#667eea',
            fontSize: '16px',
            fontWeight: 'bold',
            padding: '20px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📋</div>
            <div>左パネル</div>
            <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '10px', opacity: 0.7 }}>
              準備中...
            </div>
          </div>
        )}
      </div>

      {/* 中央パネル（通話画面） */}
      <div style={{
        flex: '1 1 40%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative'
      }}>
        {centerPanel}
      </div>

      {/* 右パネル */}
      <div style={{
        flex: '0 0 30%',
        minWidth: '300px',
        maxWidth: '400px',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderLeft: '1px solid rgba(0, 0, 0, 0.1)',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {rightPanel || (
          <div style={{ 
            textAlign: 'center',
            color: '#667eea',
            fontSize: '16px',
            fontWeight: 'bold',
            padding: '20px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>⚙️</div>
            <div>右パネル</div>
            <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '10px', opacity: 0.7 }}>
              準備中...
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DesktopPlazaLayout;

